import { render, staticRenderFns } from "./commonOrder.vue?vue&type=template&id=61e52610&scoped=true&"
import script from "./commonOrder.vue?vue&type=script&lang=js&"
export * from "./commonOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e52610",
  null
  
)

export default component.exports